import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { ApprovalApproverKind } from '../../../../../Enums/approval-types.enum';
import { AvStatusPillComponent } from '../../../../Shared/Components/av-status-pill/av-status-pill.component';
import { ApprovalStepEntry } from '../../../Types/approval-step-entry.type';
import { StepperRow } from '../../../Interfaces/approval-steps-stepper.interface';

@Component({
  selector: 'app-approval-steps-stepper',
  standalone: true,
  imports: [COMMON_IMPORTS, AvStatusPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './approval-steps-stepper.component.html',
  styleUrl: './approval-steps-stepper.component.scss',
})
export class ApprovalStepsStepperComponent {
  readonly steps = input<ReadonlyArray<ApprovalStepEntry> | null>(null);

  readonly rows = computed<StepperRow[]>(() => {
    const list = this.steps() ?? [];
    return list.map((entry, index) => this.toRow(entry, index));
  });

  readonly hasSteps = computed<boolean>(() => this.rows().length > 0);

  private toRow(entry: ApprovalStepEntry, index: number): StepperRow {
    const approver = entry.approver ?? null;
    const isGroup = approver?.kind === ApprovalApproverKind.Group;
    const name = approver?.display_name?.trim() || null;

    return {
      step: entry.step ?? index + 1,
      type: (entry.type ?? '') as string,
      approverName: isGroup ? null : name,
      approverEmail: approver?.email?.trim() || null,
      groupName: isGroup ? (approver?.group_name?.trim() || name) : null,
    };
  }
}
